import { useCallback } from "react"
import { useQueryClient } from "@tanstack/react-query"

export const useInvalidateMyGivingQueries = () => {
  const queryClient = useQueryClient()

  const invalidateMyGivingRecurringDonationsQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: ["RecurringDonations"] })
  }, [queryClient])

  const invalidateMyGivingDonationsQueries = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: ["DonationsSummary"] })
    queryClient.invalidateQueries({
      queryKey: ["Donations", new Date().getFullYear()],
    })
    queryClient.invalidateQueries({
      queryKey: ["Pledges", { current: true }],
    })
  }, [queryClient])

  return {
    invalidateMyGivingRecurringDonationsQuery,
    invalidateMyGivingDonationsQueries,
  }
}
